module.exports = __webpack_public_path__ + "img/right_nine.13c7cf82.svg";